import { render, staticRenderFns } from "./BaseTabulatorColumnEditor.vue?vue&type=template&id=65bee883&scoped=true"
import script from "./BaseTabulatorColumnEditor.vue?vue&type=script&lang=js"
export * from "./BaseTabulatorColumnEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseTabulatorColumnEditor.vue?vue&type=style&index=0&id=65bee883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bee883",
  null
  
)

export default component.exports